const getEvseIsExpandedLocalStorageKey = (evseDeviceId: string): string => `evse-is-expanded-${evseDeviceId}`

const expandedValue = 'expanded' as const

export const getIsEvseExpandedFromCache = (evseDeviceId: string): boolean => {
  return localStorage.getItem(getEvseIsExpandedLocalStorageKey(evseDeviceId)) === expandedValue
}

export const setIsEvseExpandedToCache = (evseDeviceId: string, isExpanded: boolean): void => {
  if (!evseDeviceId) return

  const key = getEvseIsExpandedLocalStorageKey(evseDeviceId)
  if (isExpanded) {
    localStorage.setItem(key, expandedValue)
  } else {
    localStorage.removeItem(key)
  }
}

export const removeEvseExpandedFromCache = (evseDeviceId: string): void => {
  const key = getEvseIsExpandedLocalStorageKey(evseDeviceId)
  localStorage.removeItem(key)
}
